//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatusPassosItem from './StatusPassosItem';

export default {
  name: 'HistoricoTransferencia',
  props: {
    passosTransferidos: {},
    sequencia: null,
    cliente: null,
  },
  data() {
    return {
      menu: false,
      passosTransferidosSeguencia: [],
    };
  },
  components: {
    StatusPassosItem,
  },
  computed: {
    passosTransferidosDaSequencia() {
      if (this.passosTransferidos && this.passosTransferidos[this.sequencia]) {
        return this.passosTransferidos[this.sequencia];
      }
      return [];
    },
    seguenciaComPassoTransferido() {
      return this.passosTransferidosDaSequencia.length;
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/workflow/HistoricoTransferencia.vue?vue&type=script&lang=js&